import produce from 'immer';
import { initialRootState } from '../initialRootState';
import { EVisibilityUiActionType, IVisibilityUiAction } from './actions';
export interface IVisibilityUiState {
  desktop: { mainLayout: boolean };
}

export const visibilityUiReducer = (
  currentState: IVisibilityUiState = initialRootState.visibilityUi,
  action: IVisibilityUiAction
): IVisibilityUiState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EVisibilityUiActionType.SHOW_MAIN_LAYOUT:
        draft.desktop.mainLayout = true;
        break;
      case EVisibilityUiActionType.HIDE_MAIN_LAYOUT:
        draft.desktop.mainLayout = false;
        break;
    }
  });
